import React, { createContext, useContext } from 'react'
import { useFormikContext } from 'formik'

export interface PreviewFormValues {
  previewName: string
  description: string
  inspectEnabled: boolean
  commentsEnabled: boolean
  passwordEnabled: boolean
  password: string
  previewExpirationEnabled: boolean
  previewExpiration: string
  selectedUUIDs: { identifier: string; type: 'PAGE' | 'PROTOTYPE' }[]
}

const PreviewFormContext = createContext<ReturnType<
  typeof useFormikContext<PreviewFormValues>
> | null>(null)

export const usePreviewForm = () => {
  const context = useContext(PreviewFormContext)
  if (!context) {
    throw new Error('usePreviewForm must be used within a PreviewFormProvider')
  }
  return context
}

export const PreviewFormProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const formikContext = useFormikContext<PreviewFormValues>()
  return (
    <PreviewFormContext.Provider value={formikContext}>
      {children}
    </PreviewFormContext.Provider>
  )
}
